// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__zhCLa","content":"RecentSearches_content__2-ajb"};